import numeral from 'numeral';
import { COUNTRIES } from '@constants';

numeral.register('locale', 'ar', {
    delimiters: {
        thousands: '',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'mm',
        billion: 'b',
        trillion: 't'
    },
    currency: {
        symbol: '$'
    }
});

if(window.country === COUNTRIES.AR){
    numeral.locale('ar');
}

export default numeral;